import script from "./sf-loading-dots.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-loading-dots.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__